import React, { useState, useEffect, useCallback } from 'react';
import SelfAssesSubmit from './SelfAssesSubmit';
import { createUserAns, getAsmtById, getUserByUserId } from '../../services/authService';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { decodeId } from '../../utills/idUtils';

import communication from '../../assets/images/communication.png'
import charishma from '../../assets/images/charishma.png'
import clarity from '../../assets/images/clarity.png'
import colloborate from '../../assets/images/colloborate.png'
import composure from '../../assets/images/composure.png'
import confidence from '../../assets/images/confidence.png'
import connection from '../../assets/images/connection.png'
import courage from '../../assets/images/courage.png'


const imageMap = {
    communication: communication,
    CHARISMA: charishma,
    CLARITY: clarity,
    COLLABORATE: colloborate,
    Composure: composure,
    CONFIDENCE: confidence,
    CONNECTION: connection,
    COURAGE: courage,
};

const SelfAssessment = ({ components, statements, plr, answers, name }) => {
    const { encodedId } = useParams();
    const id = decodeId(encodedId);
    const { state } = useAuth();
    const { user } = state;
    const userId = user?.user_id;

    const [initiatorName, setInitiatorName] = useState('');
    const [isReportShow,setIsReportShow] = useState(false);

    const [assessmentType,setAssessmentType] = useState(null);

    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(() => {
        const savedState = localStorage.getItem(`selfAssessment-${id}`);
        return savedState ? JSON.parse(savedState).savedQuestionIndex : 0; // Default to 0
    });
    const [selectedAnswers, setSelectedAnswers] = useState(() => {
        const savedState = localStorage.getItem(`selfAssessment-${id}`);
        return savedState ? JSON.parse(savedState).savedSelectedAnswers : {}; // Default to empty object
    });
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');


    useEffect(() => {
        const fetchData = (async () => {
            try {
                const getAsmtInitiatorId = await getAsmtById(id);
                const getInitiatorDetails = await getUserByUserId(getAsmtInitiatorId.source_user_id);
                console.log("getInitiatorDetails",getInitiatorDetails,getAsmtInitiatorId,name)
                setInitiatorName(name ? getInitiatorDetails?.first_name : null);
                //check assement type
                setAssessmentType(getAsmtInitiatorId?.assessment_type);
                if(getAsmtInitiatorId.assessment_type === "360"){
                  if(getAsmtInitiatorId.current_status === "Completed"){
                    setIsReportShow(true);
                  }else{
                    setIsReportShow(false);
                  }
                }else{
                    setIsReportShow(true);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        }); // Add id as a dependency
        if (id) {
            fetchData();
        }
    }, [id, name]);

    useEffect(() => {
        const savedState = localStorage.getItem(`selfAssessment-${id}`);
        window.scrollTo(0, 0);

        if (savedState) {
            const { savedQuestionIndex, savedSelectedAnswers } = JSON.parse(savedState);
            setCurrentQuestionIndex(savedQuestionIndex);
            setSelectedAnswers(savedSelectedAnswers);
        }

        // Call fetchData after loading saved state

    }, [id]);

    useEffect(() => {
        // Save state to localStorage whenever currentQuestionIndex or selectedAnswers change
        if (id) {
            localStorage.setItem(
                `selfAssessment-${id}`,
                JSON.stringify({
                    savedQuestionIndex: currentQuestionIndex,
                    savedSelectedAnswers: selectedAnswers,
                })
            );
        }
    }, [id, currentQuestionIndex, selectedAnswers]);


    // Save current state to local storage when moving to the next question or on submission
    const saveState = () => {
        localStorage.setItem(`selfAssessment-${id}`, JSON.stringify({
            savedQuestionIndex: currentQuestionIndex,
            savedSelectedAnswers: selectedAnswers
        }));
    };

    // Save and continue to the next question
    const handleContinue = () => {
        if (!selectedAnswers[currentStatement.statement_id]) {
            setErrorMessage('Please answer the current question before continuing.');
            setTimeout(() => setErrorMessage(''), 3000);
            return;
        }

        saveState(); // Save the current state
        setCurrentQuestionIndex(prevIndex => Math.min(prevIndex + 1, statements.length - 1));
    };


    const currentStatement = statements[currentQuestionIndex];
    const currentComponent = currentStatement
        ? components.find(c => c.component_id === currentStatement.component_id)
        : null;
    const currentPillar = currentComponent
        ? plr.find(p => p.pillar_id === currentComponent.pillar_id)
        : null;

    const currentAnswers = answers.filter(
        answer => answer.statement_id === currentStatement.statement_id
    );

    const handleAnswerSelection = (answerId) => {
        setSelectedAnswers((prev) => {
            const updatedAnswers = {
                ...prev,
                [currentStatement.statement_id]: answerId,
            };

            return updatedAnswers;
        });

        setTimeout(() => {
            if (currentQuestionIndex < statements.length - 1) {
                setCurrentQuestionIndex((prevIndex) =>
                    Math.min(prevIndex + 1, statements.length - 1)
                );
            }
        }, 100);
    };


    const submitAnswers = async (answersData) => {
        const submissionData = {
            assessment_id: id,
            user_id: userId,
            userAnswers: answersData
        };
        await createUserAns(submissionData);
    };

    const handleSubmit = () => {
        if (Object.keys(selectedAnswers).length < statements.length) {
            setErrorMessage('Please answer all questions before submitting.');
            setTimeout(() => setErrorMessage(''), 3000);
            return;
        }

        const submissionData = Object.keys(selectedAnswers).map(statementId => ({
            statement_id: parseInt(statementId, 10),
            answer_id: selectedAnswers[statementId]
        }));

        submitAnswers(submissionData);
        saveState(); // Save state on submit as well
        setIsSubmitted(true);
        setErrorMessage('');
    };



    if (isSubmitted) {
        return <SelfAssesSubmit initiator={initiatorName} selectedAnswers={selectedAnswers} answers={answers} isReportShow={isReportShow} assessmentType={assessmentType} setIsReportShow={setIsReportShow}/>;
    }

    if (!currentStatement) {
        return <div>Error: No statement found for the current question index.</div>;
    }

    return (
        <>
            <div className="bg-blue-600 text-white text-center py-2 font-bold lg:text-3xl text-xl pb-5 text-blue-600 lg:py-4">


                {/* {name ? `Questions related to ${initiatorName}` : `Self Assessment`} */}
                {name ? `Please answer the following questions about  ${initiatorName} to help them assess their executive presence` : `Self Assessment`}
            </div>
            <div className="bg-gray-200 py-2 lg:flex justify-center items-center px-4 gap-6">
                <h2 className="text-lg mb-1">Question {currentQuestionIndex + 1} of {statements.length}</h2>
                <div className="flex items-center space-x-1 lg:space-x-2">
                    {statements.map((statement, index) => (
                        <button
                            key={index}
                            onClick={() => {
                                if (index < currentQuestionIndex) {
                                    setCurrentQuestionIndex(index);
                                    return;
                                }

                                if (index > currentQuestionIndex && !selectedAnswers[currentStatement?.statement_id]) {
                                    setErrorMessage('Please answer the current question before moving to the next one.');
                                    setTimeout(() => setErrorMessage(''), 3000);
                                    return;
                                }

                                setCurrentQuestionIndex(index);
                            }}
                            className={`rounded-full transition-colors duration-1000 
                                ${currentQuestionIndex === index 
                                    ? 'bg-green-500 w-5 h-5'        // Bigger size for current question
                                    : selectedAnswers[statement.statement_id] 
                                        ? 'bg-blue-600 w-4 h-4 duration-1000'   // Normal size for answered
                                        : 'bg-gray-400 w-4 h-4 duration-1000'    // Normal size for unanswered
                                }`}

                        />
                    ))}
                </div>
            </div>



            <div style={{ userSelect: "none" }} className="min-h-screen bg-white lg:px-16">

                {errorMessage && (
                    <p className="text-red-500 tracking-wider font-extrabold my-1 text-center">{errorMessage}</p>
                )}

                <div className="lg:flex justify-center items-start mt-1 px-4 lg:h-[500px] lg:mb-1">
                    <div className="lg:w-1/2 flex flex-col items-center">
                        <div className="flex  justify-center align-middle items-center lg:p-1 p-4">
                            <div className="lg:text-3xl font-bold tracking-wider lg:mb-2 mb-0">
                                <h3 className='uppercase text-gray-500'>{currentPillar ? currentPillar.pillar_name : 'Pillar Not Found'}<br /></h3>
                                <h5 className="text-blue-900 text-center">
                                    {currentComponent
                                        ? currentComponent.component_name.charAt(0).toUpperCase() + currentComponent.component_name.slice(1).toLowerCase()
                                        : 'Component Not Found'}
                                </h5>

                            </div>
                        </div>

                        <img
                            src={
                                currentComponent?.component_picture_url &&
                                    currentComponent.component_picture_url.startsWith("http")
                                    ? currentComponent.component_picture_url
                                    : imageMap[currentComponent?.component_name] || imageMap["communication"]
                            }
                            alt={currentComponent?.component_name || "Placeholder Image"}
                            className="w-1/2 lg:h-[300px] h-[190px] object-contain rounded-lg m-4"
                        />
                        <p className="text-blue-600 text-center lg:p-4 lg:text-lg lg:min-h-[80px] sm:text-sm sm:min-h-auto break-words overflow-hidden">
                            {currentComponent.component_description}
                        </p>
                    </div>
                    <div
                        className="lg:w-1/2 bg-white p-4 rounded-lg lg:h-[500px] lg:max-h[500px] shadow-md animate-fadeIn"
                    >
<div className="mb-1">
  <div className="min-h-[7.75rem] flex items-center"> {/* 3 lines * 1.5rem (approx line height) = 4.5rem or 6.75rem for lg:text-3xl */}
    <span
      className={`font-bold lg:text-3xl text-xl pb-5 text-blue-600 lg:py-4 sm:text-sm break-words`}
    >
      {name
        ? currentStatement.other_statement_text.replace("{{assessee}}", initiatorName)
        : currentStatement?.self_statement_text || "No statement available."}
    </span>
  </div>
</div>


                        <div className="space-y-2 lg:h-[340px]">
                            {currentAnswers.length > 0 ? (
                                currentAnswers.map((answer) => (
                                    <label
                                        key={answer.answer_id}
                                        className={`flex items-center cursor-pointer p-3 border rounded-lg transition-all duration-500 
            ${selectedAnswers[currentStatement.statement_id] === answer.answer_id
                                                ? 'border-blue-600 border-2 bg-blue-100 '
                                                : 'border-gray-300 hover:bg-blue-50 animate-fadeIn'
                                            }`}
                                    >
                                        <input
                                            type="radio"
                                            className="hidden"
                                            id={`option${answer.answer_id}`}
                                            name={`statement${currentStatement.statement_id}`}
                                            checked={selectedAnswers[currentStatement.statement_id] === answer.answer_id}
                                            onChange={() => handleAnswerSelection(answer.answer_id)}
                                        />
                                        <span
                                            className={`w-8 h-8 flex items-center justify-center border rounded-full mr-4 transition-all duration-100 
              ${selectedAnswers[currentStatement.statement_id] === answer.answer_id
                                                    ? 'border-blue-600 bg-blue-600 text-white '
                                                    : 'border-gray-300 text-gray-600'
                                                }`}
                                        >
                                            {answer.answer_shortcode}
                                        </span>
                                        <span>{answer.answer_text}</span>
                                    </label>
                                ))
                            ) : (
                                <p className="">No answers available for this statement.</p>
                            )}
                        </div>
                    </div>

                </div>

                <div className="flex justify-between mt-4 mb-4 p-5 lg:px-10">
                    {currentQuestionIndex > 0 ? (
                        <button
                            onClick={() => setCurrentQuestionIndex(prev => Math.max(prev - 1, 0))}
                            disabled={currentQuestionIndex === 0}
                            className="p-2 bg-blue-500 text-white rounded-full"
                        >
                            <i className="fas fa-chevron-left"></i> Previous Question
                        </button>
                    ) : (
                        <p> </p>
                    )}
                    {currentQuestionIndex < statements.length - 1 ? (
                        <button
                            onClick={handleContinue}
                            className="p-2 bg-blue-500 text-white rounded-full"
                            disabled={selectedAnswers[currentStatement.statement_id] === undefined}
                        >
                            Next Question <i className="fas fa-chevron-right"></i>
                        </button>
                    ) : (
                        // "Submit All Answers" button for the last question and only if the last question is answered
                        <button
                            onClick={handleSubmit}
                            className={`p-2 rounded-full text-white ${Object.keys(selectedAnswers).length === statements.length
                                ? 'bg-green-500'
                                : 'bg-gray-400 cursor-not-allowed'
                                }`}
                            disabled={Object.keys(selectedAnswers).length !== statements.length}
                        >
                            Submit All Answers
                        </button>
                    )}

                </div>
            </div>
        </>
    );
};

export default SelfAssessment;
